var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShade(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 284.404,
    height: 261.117,
    viewBox: "0 0 284.404 261.117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13616",
    "data-name": "Group 13616",
    transform: "translate(-4197 -4520)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9456",
    "data-name": "Path 9456",
    d: "M212.79,76.72h77.949v72.843Z",
    transform: "translate(4189.619 4443.28)",
    fill: "#c5c9ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9457",
    "data-name": "Path 9457",
    d: "M215.812,76.72,342.557,192.152v47.954L161.09,76.72Z",
    transform: "translate(4137.801 4443.28)",
    fill: "#c5c9ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9458",
    "data-name": "Path 9458",
    d: "M109.68,76.72h51.759L394.084,287.48v50.357Z",
    transform: "translate(4087.32 4443.28)",
    fill: "#c5c9ca"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShade);
export default __webpack_public_path__ + "static/media/shade.78fb0ec46c70456f57b0e3f864e42aee.svg";
export { ForwardRef as ReactComponent };